import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = { // leads
  one_time: {
    kpis: {},
    campaigns: [],
  },
  recurring: {
    kpis: {},
    campaigns: [],
  },
  campaign_sub_logs: [],
  loading: false,
  editing: false
}

let changes = null;
export default function campaignLeadTrackReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}CAMPAIGN_LEADS_TRACK_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}CAMPAIGN_LEADS_TRACK_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_SUB_LOGS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_LEADS_TRACK_LOAD_FULFILLED`:
      changes = {
        [response.meta.schedule_type]: {
          kpis: response.meta.analytics_kpis || {},
          campaigns: response.campaigns || [],
        },
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_SUB_LOGS_LOAD_FULFILLED`:
      changes = {
        campaign_sub_logs: response.campaign_logs || [],
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_LEAD_TRACK_EDIT`:
      changes = {
        editing: action.data,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_LEAD_TRACK_EDIT_CANCEL`:
      changes = {
        editing: false,
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}